// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { PublishInvoiceConfigDTO } from '../../../../../Types/LogT';

const PublishInvoice: FC<{ config: unknown }> = ({ config }) => {
  const { entityReference } = config as PublishInvoiceConfigDTO;

  if (!entityReference) {
    return (
      <Text italic color="red">
        {i18n._('step.config.general-error')}
      </Text>
    );
  }

  const { label } = entityReference;

  return (
    <Text>
      Dokument <b>{label}</b> hochladen
    </Text>
  );
};

export default PublishInvoice;
